var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilePdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.88232C0 1.63969 1.00736 0.632324 2.25 0.632324H7.6287C8.2254 0.632324 8.79772 0.869377 9.21968 1.29133L11.341 3.41266C11.7629 3.83461 12 4.40691 12 5.00365V13.3823C12 14.625 10.9927 15.6323 9.75 15.6323H2.25C1.00736 15.6323 0 14.625 0 13.3823V2.88232ZM2.25 2.13232C1.83579 2.13232 1.5 2.46811 1.5 2.88232V13.3823C1.5 13.7965 1.83579 14.1323 2.25 14.1323H9.75C10.1642 14.1323 10.5 13.7965 10.5 13.3823V5.00365C10.5 4.80473 10.4209 4.61397 10.2803 4.47331L8.15903 2.35199C8.01832 2.21134 7.8276 2.13232 7.6287 2.13232H2.25ZM3 6.63232C3 6.21811 3.33579 5.88232 3.75 5.88232H8.25C8.66422 5.88232 9 6.21811 9 6.63232C9 7.04655 8.66422 7.38232 8.25 7.38232H3.75C3.33579 7.38232 3 7.04655 3 6.63232ZM3 9.63232C3 9.2181 3.33579 8.88232 3.75 8.88232H6.75C7.16423 8.88232 7.5 9.2181 7.5 9.63232C7.5 10.0465 7.16423 10.3823 6.75 10.3823H3.75C3.33579 10.3823 3 10.0465 3 9.63232Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePdf);
export default __webpack_public_path__ + "static/media/filePdf.76c70e67ac05f6b4c1c9e7a6f9f8bce5.svg";
export { ForwardRef as ReactComponent };